import Vue from 'vue'
import axios from 'axios'
import i18n from '../../i18n/i18n'

const axiosInst = axios.create({
  headers: {
    'accept-language': i18n.locale,
    'Accept': 'application/json',
    'Authorization': `Bearer ${  localStorage.getItem('token')}`
  }
})

Vue.prototype.$http = axiosInst

export default axiosInst